import React, { Component } from "react";

import LocalizedLink from "../../containers/LocalizedLink";

class Footer extends Component {
  state: {
    intervalId: 0
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - 50);
  }

  scrollTop() {
    let intervalId = setInterval(this.scrollStep.bind(this), 12);
    this.setState({ intervalId: intervalId });
  }

  render() {
    return (
      <footer className="footer">
        <a
          href="http://www.ober-surfaces.com/"
          className="footer__item footer__item--25"
          target="_blank"
          rel="noopener noreferrer"
        >
          {this.props.t("common:footerOberSurfacesBrand")}
        </a>

        <LocalizedLink to="/terms" className="footer__item footer__item--25">
          {this.props.t("common:footerLegals")}
        </LocalizedLink>

        <div
          className="footer__item footer__item--50 footer__item--anchor"
          onClick={() => {
            this.scrollTop();
          }}
        >
          <i className="footer__icon i-arrow-top-light" />
          &nbsp;{this.props.t("common:footerPageOnTop")}
         </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/shared/Footer.js